module.exports = __webpack_public_path__ + "img/gina1.32790546.png";